import { cn } from '@rematter/ui-web/lib';

import { ItemAliasRecord } from '../../../types/inventoryItem';

import { ItemAliasFormFields } from './ItemAliasFormFields';

type Props = {
  itemAlias?: ItemAliasRecord | null;
  disabled?: boolean;
  className?: string;
};

export const ItemAliasDetailsForm = ({
  itemAlias,
  disabled = false,
  className,
}: Props) => (
  <div className={cn('@ItemAliasDetailsForm', className)}>
    <ItemAliasFormFields
      disabled={disabled}
      showTimestamps
      itemAlias={itemAlias}
    />
  </div>
);
